<template>
  <div class="module">
    <h4>Video</h4>
    <button v-if="active && !required" class="remove btn btn-outline-dark btn-sm" @click.stop.prevent="$emit('remove', index)">x</button>
    <button v-if="!active" class="add btn btn-outline-dark btn-sm" @click.stop.prevent="$emit('add', index, $options.defaultModel)">+</button>
    <div v-if="active" class="row">
      <div class="col-sm-6">
        <!-- <select v-model="module.video" class="form-control">
          <template v-for="(videoName, index) in videoOptions">
            <option :key="index" :value="videoName">{{ videoName }}</option>
          </template>
        </select> -->
        <input v-model="module.video" placeholder="path/to/video" type="text" class="form-control">
        <small class="text-muted">Folder name</small>
      </div>
      <div class="col-sm-2">
        <input v-model.number="module.startTime" placeholder="0" type="number" class="form-control">
        <small class="text-muted">Start</small>
      </div>
      <div class="col-sm-2">
        <input v-model.number="module.delay" placeholder="0" type="number" class="form-control">
        <small class="text-muted">Delay</small>
      </div>
      <div class="col-sm-2">
        <input v-model.number="module.duration" placeholder="30" type="number" class="form-control">
        <small class="text-muted">Duration</small>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'rph-slides-vue/src/mixins/validationMixin.js'
import { moduleMixin } from 'rph-slides-vue/src/mixins/moduleMixin.js'

export default {
  name: 'VideoModule',
  mixins: [validationMixin, moduleMixin],
  defaultModel: {
    type: 'VideoModule',
    video: '',
    startTime: 0,
    delay: 0,
    duration: 30
  },
  data: function () {
    return {
      // videoOptions: []
    }
  },
  created: function () {
    // this.$socket.emit('/media/getdirlist', { path: '/Backgrounds/Videos' }, this.onVideosLoaded)
  },
  methods: {
    // onVideosLoaded: function (result) {
    //   this.videoOptions = result.data
    // }
  }
}
</script>
